// extracted by mini-css-extract-plugin
module.exports = {"drugEdit":"admin-portal__DrugEdit__drugEdit","detailsView":"admin-portal__DrugEdit__detailsView"};